import React, {ReactElement, useState} from "react";
import {Button, Card, InputBase} from "@mui/material";
import {PD_MD, PD_SM} from "@/shared/dimens";
import {mediumGray} from "@/shared/colors";

export function CommentInputPopup({position, onSubmit, onClose}: {
  position: { x: number, y: number },
  onSubmit: (text: string) => void,
  onClose: () => void,
}): ReactElement {
  const [text, setText] = useState("");
  return <>
    <div
      style={{position: "fixed", top: 0, left: 0, right: 0, bottom: 0, zIndex: 20}}
      onClick={onClose}
    />
    <Card style={{
      position: "absolute",
      left: position.x,
      top: position.y,
      zIndex: 21,
      width: 260,
      padding: PD_MD,
      display: "flex",
      flexDirection: "column",
      gap: PD_SM,
    }}>
      <InputBase
        autoFocus
        multiline
        minRows={2}
        maxRows={4}
        placeholder="Add a comment..."
        value={text}
        onChange={e => setText(e.target.value)}
        onKeyDown={e => {
          if (e.key === "Enter" && !e.shiftKey && text.trim()) {
            e.preventDefault();
            onSubmit(text.trim());
          }
        }}
        style={{
          border: `1px solid ${mediumGray}66`,
          borderRadius: 4,
          padding: `${PD_SM}px ${PD_MD}px`,
          fontSize: 14,
        }}
      />
      <div style={{display: "flex", justifyContent: "flex-end", gap: PD_SM}}>
        <Button size="small" onClick={onClose}>Cancel</Button>
        <Button size="small" variant="contained" disabled={!text.trim()} onClick={() => onSubmit(text.trim())}>
          Add
        </Button>
      </div>
    </Card>
  </>;
}
